import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import AbTest from './AbTest';
import GroupDetail from './GroupDetail';

const Creative = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));
  let devLocation;
  if (window.origin === 'https://admfe4.mobon.net') {
    devLocation = 'https://mac4.mobon.net';
  } else {
    devLocation = 'https://adcenter.mobon.net';
  }

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="Creative"
        tabMenuList={tabList()}
        tabs={{
          '/report/creative/statistics': {
            tabComponent: <Statistics devLocation={devLocation} />,
          },
          '/report/creative/abTest': {
            tabComponent: <AbTest devLocation={devLocation} />,
            isPop: 1,
          },
          '/report/creative/detail': {
            tabComponent: <GroupDetail devLocation={devLocation} />,
            isPop: 1,
          },
        }}
      />
    </MainTemplate>
  );
};

export default Creative;
